<script setup lang="ts">
import Skeleton from "primevue/skeleton";

interface IProps {
  title?: string;
  subtitle?: string;
  isLoading?: boolean;
}

const props = defineProps<IProps>();
</script>

<template>
  <div class="flex justify-between items-center py-7">
    <div
      v-if="props.isLoading"
      class="flex flex-col gap-1"
    >
      <Skeleton class="!h-[35px] !w-[200px]" />
      <Skeleton class="!h-[25px] !w-[400px]" />
    </div>

    <div
      v-else
      class="flex flex-col gap-1"
    >
      <slot name="title">
        <h3 v-if="props.title">
          {{ props.title }}
        </h3>
      </slot>
      <slot name="subtitle">
        <span
          v-if="props.subtitle"
          class="text-text-secondary"
        >
          {{ props.subtitle }}
        </span>
      </slot>
    </div>

    <div>
      <slot />
    </div>
  </div>
</template>
